export const OPEN_SERVICE_DESK_REQUEST_EVENT = 'service-desk:open-request';

export const openServiceDeskRequest = () => {
  dispatchEvent(new Event(OPEN_SERVICE_DESK_REQUEST_EVENT));
};
